import './index.css';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { render } from 'react-dom';

render(<App />, document.getElementById("root"));


